export default {
  home: {
    minute: "Minute",
    hour: "Stunde",
    days: "Tage",
    price_info:
      "Die ersten {mianfei} Minuten sind kostenlos. Die maximale Gebühr für 24 Stunden beträgt {currencyName}{fengding}. Deine Kaution {currencyName}{yajin} wird automatisch zurückerstattet, nachdem du die Powerbank zurückgegeben hast",
    feature_1: "Enthält alle Kabeltypen: iPhone, Type‑C",
    feature_2: "Kann an jeder Station zurückgegeben werden",
    feature_3: "Kabelloses Laden verfügbar",
    tips_1:
      "Deine Kaution {currencyName}{yajin} wird am Ende der Miete zurückerstattet",
    tips_2:
      "Die Auflade‑Kaution {currencyName}{yajin} kann für die Miete genutzt und nach Verbrauch erstattet werden",
    tips_3:
      "Das aktuelle Guthaben beträgt {currencyName}{myyue} und kann direkt für die Miete verwendet werden",
    submit: "Miete starten",
    borrow: "Mieten",
    msg_fail_title: "Fehler",
    msg_fail_content: "Miete fehlgeschlagen, bitte erneut versuchen",
    msg_rentcount: "Du hast {zujieNum} nicht geschlossene Bestellungen",
    goborrow: "Losladen!!!",
    nearby: "Nahegelegene Stationen ansehen",
    preauth: "Vorautorisierung"
  },
  login: {
    code_title: "SMS‑Verifizierung",
    phone_number: "Telefonnummer",
    verification_code: "Bitte gib den Bestätigungscode aus der SMS ein",
    captcha_code: "Code",
    send_code: "Code senden",
    login: "Anmelden",
    agree: "Mit Klick auf Anmelden stimmst du ",
    readme: "der Nutzungsvereinbarung zu",
    msg_fail_login: "Anmeldung fehlgeschlagen",
    msg_success_login: "Erfolgreich angemeldet",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Erneut versuchen?",
    sign_in_with: "Anmelden mit",
    no_sms: "Keine SMS erhalten",
    retry: "Erneut senden"
  },
  confirm: {
    deletecard: "Karte löschen",
    addcard: "Kartendaten eingeben",
    title: "Zahlungsbestätigung",
    paynow: "Sofortzahlung",
    SMSConfirm:
      "Bitte bezahle entsprechend der SMS auf deinem Telefon und klicke auf Bestätigen, um fortzufahren.",
    pay_label: "Betrag",
    auth_label: "Vorautorisierung",
    price_tips:
      "Dein Guthaben kann auf Anfrage ausgezahlt werden. Es kann 1–5 Werktage dauern, bis es auf deinem Zahlungskonto erscheint.",
    auth_tips:
      "Eine Vorautorisierung in Höhe von {0}{1} ist erforderlich. Der tatsächliche Mietbetrag wird bei der Rückgabe der Powerbank abgebucht.",
    pay_type: "Bitte wähle deine bevorzugte Zahlungsmethode",
    submit: "Zahlung bestätigen",
    msg_loading: "Wird geladen...",
    msg_fail_title: "Warnung",
    msg_fail_payment: "Einzahlung konnte nicht gestartet werden",
    msg_fail_order: "Mietbestellung konnte nicht erstellt werden",
    msg_fail_support: "System wird nicht unterstützt",
    msg_fail_confirm: "Bestätigen",
    msg_fail_retry: "Erneut versuchen",
    msg_fail_cancel: "Abbrechen"
  },
  mine: {
    title: "Benutzerprofil",
    wallet: "Mein Wallet",
    balance: "Mein Guthaben",
    deposit: "Kaution",
    wallet_in: "Aufladen",
    wallet_out: "Auszahlen",
    wallet_log: "Wallet‑Verlauf",
    rental_history: "Mietverlauf",
    payment_title: "Zahlungsmethoden",
    download_app: "App herunterladen",
    settings: "Einstellungen",
    help: "Hilfe",
    logout: "Abmelden",
    login_tips: "Bitte anmelden",
    msg_fail_title: "Fehler",
    msg_fail_update: "Änderung fehlgeschlagen. Bitte erneut versuchen",
    msg_loading: "Wird geladen...",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Erneut versuchen?",
    edit_profile: "Profil bearbeiten",
    join_us: "WERDE TEIL VON UNS",
    join_us_details: "Erhalte eine Cargamos‑Station an deinem Standort"
  },
  msg: {
    appoffline: "Die App wurde noch nicht gestartet, bitte warten",
    deletecard: "Möchtest du diese Karte wirklich löschen?",
    no_phone: "Telefonnummer ist erforderlich",
    loading: "Wird geladen...",
    title: "Hinweis",
    success: "Vorgang erfolgreich",
    error: "Unbekannter Fehler. Bitte später erneut versuchen",
    roleerror:
      "Unzureichende Berechtigungen. Bitte Administrator kontaktieren.",
    neterror:
      "Netzwerkverbindung fehlgeschlagen. Bitte später erneut versuchen",
    confirm: "Bestätigen",
    retry: "Erneut versuchen",
    cancel: "Abbrechen",
    title_fail: "Warnung",
    vieworder: "Bestellung anzeigen",
    success_payment: "Zahlung abgeschlossen",
    success_buy: "Kauf abgeschlossen",
    fail_payment: "Zahlung fehlgeschlagen",
    keyword: "Stichwort",
    ispayorder: "Bitte bestätigen, ob die Zahlung erfolgt ist",
    unpay: "Unbezahlt",
    yespay: "Bezahlt",
    notopen: "Noch nicht geöffnet"
  },
  result: {
    tips:
      "Um Bestellungen und andere Stationsstandorte anzuzeigen, lade bitte die App herunter.",
    download: "App herunterladen",
    title: "Miete bestätigt",
    gotit: "Verstanden",
    price_plan: "Tarif",
    msg_success: "Erfolgreich gemietet",
    msg_tips_loading: "Die Powerbank wird ausgegeben, bitte warten...",
    msg_result_loading: "Das Zahlungsergebnis wird bestätigt...",
    msg_fail_confirm: "Bestätigen",
    btn_usage: "Nutzungshinweis",
    btn_return: "Rückgabehinweis",
    deposit: "Kaution",
    msg_fail_content: "Anfrage fehlgeschlagen. Bitte erneut versuchen.",
    price_label: "pro Stunde",
    price_info:
      "Die ersten {mianfei} Minuten sind kostenlos, maximale Tagesgebühr {ccurrency}{fengding}. Die Kaution wird automatisch abgezogen, sobald die Miete {ccurrency}{yajin} erreicht",
    tips_1: "Bitte entnimm die Powerbank Nr. {number} wie im Bild gezeigt",
    tips_2:
      "Bitte ordne die Kabel und setze die Powerbank in den Slot mit der Seite mit [Pfeilen nach unten] ein",
    msg_note_usage:
      "Die Powerbank verfügt über 3 Kabeltypen, wähle den passenden für dein Gerät.",
    msg_note_return:
      "Bitte ordne die Kabel und setze die Powerbank in den Slot mit der Seite mit [Pfeilen nach unten] ein",
    return_info:
      "Bei der Rückgabe bitte darauf achten, dass die Kabel ordentlich sind, und die Seite mit Metallkontakten in einen freien Steckplatz bis zum Anschlag einführen.",
    download_tips:
      "Um unsere Powerbank zu mieten, kannst du eine der folgenden Optionen wählen"
  },
  result_msg: {
    loading: "Wird geladen...",
    refresh: "Aktualisieren"
  },
  order: {
    title: "Mietverlauf",
    in_use: "In Benutzung",
    ended: "Beendet",
    msg_error: "Anfrage fehlgeschlagen",
    order_number: "Nr.",
    order_details: "Bestelldetails",
    order_zj_shop: "Mietort",
    order_zj_time: "Mietzeit",
    order_gh_shop: "Rückgabeort",
    order_gh_time: "Rückgabezeit",
    order_use_time: "Nutzungsdauer",
    order_amount: "Gesamtbetrag",
    not_on_rent: "Nicht gemietet",
    renting: "In Miete",
    undone: "Nicht abgeschlossen",
    returned: "Zurückgegeben",
    questions: "Fragen",
    timeout_to_return: "Rückgabe überschritten",
    suspended_for_billing: "Für Abrechnung gesperrt"
  },
  order_item: {
    order_number: "Nr.",
    venue_rented: "Abholort",
    time_rented: "Abholzeit",
    venue_returned: "Rückgabeort",
    time_returned: "Rückgabezeit",
    charge_standard: "Tarif",
    charge_standard_info:
      "{pJifei} {pCurrency} pro Stunde (erste {pMian} Min gratis)",
    rent_occurred: "Miete erfolgt",
    returned: "Zurückgegeben",
    unreturned: "Nicht zurückgegeben",
    type_0: "Nicht abgeschlossen",
    type_1: "In Miete",
    type_2: "Storniert",
    type_3: "Zurückgegeben",
    type_4: "Fehler aufgetreten",
    type_5: "Überzogen",
    min: "Min",
    payment: "Zahlung"
  },
  setting: {
    title: "Einstellungen",
    lang: "Sprache"
  },
  help: {
    title: "FAQ",
    rentals: "Mieten",
    venues: "Standorte",
    payments: "Zahlungen"
  },
  wallet_in: {
    title: "Guthaben aufladen",
    price_label: "Aufladebetrag",
    price_placeholder: "Bitte Aufladebetrag eingeben",
    balance: "Aktuelles Guthaben",
    price_auto: "Zahlungsbetrag wählen",
    price_tips:
      "Dein Guthaben kann auf Anfrage ausgezahlt werden. Es kann 1–5 Werktage dauern, bis es auf deinem Zahlungskonto erscheint.",
    submit: "Absenden",
    loading: "Wird geladen...",
    paying: "Weiterleitung zur Zahlungsseite...",
    msg_title: "Hinweise",
    msg_fail_order: "Aufladebestellung konnte nicht erstellt werden",
    msg_fail_payment: "Aufladezahlung konnte nicht gestartet werden",
    msg_fail_retry: "Erneut versuchen"
  },
  wallet_out: {
    title: "Auszahlung",
    price_label: "Auszahlungsbetrag",
    price_placeholder: "Bitte Auszahlungsbetrag eingeben",
    balance: "Aktuelles Guthaben",
    balance_all: "Alles auszahlen",
    deposit: "Kaution",
    deposit_tips:
      "Es gibt eine offene Mietbestellung. Die Kaution von Ksh{pyajin} ist nicht erstattungsfähig",
    submit: "Absenden",
    apply: "Beantragen",
    confirm: "Bestätigen",
    loading: "Wird geladen...",
    msg_fail_price: "Der Auszahlungsbetrag ist falsch",
    msg_fail_balance:
      "Der Auszahlungsbetrag darf das aktuelle Guthaben nicht überschreiten",
    msg_fail_submit: "Bitte alle erforderlichen Informationen ausfüllen",
    msg_title: "Fehler",
    msg_success_content: "Erstattung erfolgreich",
    confirmtitle: "Hinweise",
    confirmcontent:
      "Das aktuelle Wallet unterstützt keine Barauszahlung. Bitte hinterlasse deine Kontaktdaten für die manuelle Erstattung",
    payee_name: "Empfängername",
    payee_bankcard: "Bankkartennummer",
    payee_phone: "Telefon",
    cancelText: "Abbrechen",
    confirmText: "Erneut beantragen"
  },
  map: {
    在线: "Geöffnet",
    离线: "Geschlossen",
    title: "Nahegelegene Station",
    result_msg: "Keine Station in der Nähe gefunden",
    msg_title: "fehler",
    no_support:
      "Entschuldigung! Dein Browser unterstützt keine Standortdienste",
    my_position: "Mein Standort",
    distance: "Entfernung:",
    shop_time: "Öffnungszeiten",
    free: "Zur Miete verfügbar",
    return: "Verfügbare freie Slots",
    shop_title: "Standortdetails",
    address: "Adresse",
    go_here: "Hierhin",
    nav_help: "Hilfe",
    nav_search: "Suche"
  },
  scanQr: {
    NotAllowedError: "Du musst den Kamerazugriff erlauben",
    NotFoundError: "Auf diesem Gerät gibt es keine Kamera",
    NotSupportedError: "Sicherer Kontext erforderlich (HTTPS, localhost)",
    NotReadableError: "Die Kamera wird verwendet",
    OverconstrainedError: "Die Kameraeinstellung ist nicht geeignet",
    StreamApiNotSupportedError:
      "Dieser Browser unterstützt die Streaming‑API nicht"
  },
  payment: {
    payment_title: "Zahlungsmethoden",
    pay_type: "Bitte füge deine Kartendaten hinzu",
    add_payment_card: "Zahlungskarte hinzufügen",
    add_payment: "Zahlung hinzufügen"
  },
  shop: {
    title: "Nahegelegene Station",
    search_station: "Station suchen",
    search_station_tips: "Bitte Stationsnamen eingeben",
    shop_power_banks: "Powerbanks",
    shop_empty_slots: "Leere Slots",
    shop_address: "Adresse",
    shop_business_hours: "Öffnungszeiten",
    shop_directions_station: "Wegbeschreibung zur Station",
    shop_scan_qrcode: "QR scannen"
  },
  paymethod: {
    payamount: "Zahlungsbetrag",
    choosepaymethod: "Zahlungsoptionen wählen",
    addcard: "Neue Karte hinzufügen",
    confrimpay: "Zahlung bestätigen",
    借记卡: "Debitkarte",
    银行卡列表: "Bankkartenliste"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} pro {pJifeiDanwei} {priceUnit}",
    price2: "Bis zu {pFengding} {pCurrencyName} pro 24 Stunden",
    price3: "Nicht‑Rückgabe‑Gebühr {overtimeAmount} {pCurrencyName}",
    venuerented: "Mietort",
    venuereturned: "Rückgabeort",
    timerented: "Mietzeit",
    timereturned: "Rückgabezeit",
    powerbankid: "Powerbank‑ID",
    getreceipt: "BELEG ERHALTEN",
    buypowerbank: "Diese Powerbank kaufen",
    usetime: "Nutzungszeit",
    estimatedamount: "Geschätzter Betrag",
    feerule: "Tarifregel",
    payment: "Zahlung",
    orderNo: "Bestell‑Nr.",
    trafficDetails: "Paket‑Traffic‑Details ansehen",
    Renewals: "Verlängerungen",
    FeeSchedule: "Gebührenplan",
    HowToUse: "So funktioniert’s",
    LeaseMerchant: "Vermieter",
    startTime: "Startzeit",
    ReturningMerchants: "Rückgabeorte",
    EndTime: "Endzeit",
    Deposit: "Kaution",
    fee1: "Gerätekaution {overtimeAmount} {pCurrencyName}",
    fee2:
      "Rückgabe innerhalb von {overtime} Tagen nach Ablauf des Mietdatums, minus {pFengding} {pCurrencyName} pro 24 Stunden.",
    fee3:
      "Wenn das Gerät innerhalb von {overtime} Tagen nach Ablauf der Mietdauer zurückgegeben wird, werden {overtimeAmount} {pCurrencyName} abgezogen.",
    fee4:
      "Die Kaution wird automatisch abgezogen, wenn das Gerät mehr als 15 Tage nach Ablauf der Miettage nicht zurückgegeben wird.",
    rentagain: "Erneut mieten",
    onrental: "In Miete",
    revoked: "Widerrufen",
    returned: "Zurückgegeben",
    issue: "Problem",
    overtimereturn: "Überfällig"
  },
  selectpackage: {
    powerbank: "Powerbank",
    powerstation: "Station",
    wifibox: "Wi‑Fi‑Box",
    choosepackage: "Datenpaket wählen",
    minute: "Minute",
    首次免费: "Kostenlos für die ersten ",
    最大每日收费: "Maximale Tagesgebühr ",
    devicedeposit: "Gerätekaution",
    return_will_back: "Kaution nach Rückgabe des Geräts zurückerhalten",
    lengthofuse: "Nutzungsdauer",
    amountcharged: "Aufgelaufener Betrag",
    release_powerbank: "Powerbank freigeben",
    see_pricing: "Preise ansehen",
    deposit: "Kaution",
    agreen: "Mit der Fortsetzung stimmst du unserer ",
    privacy_policy: "Datenschutzerklärung",
    and: " und ",
    terms_and_conditions: "den Nutzungsbedingungen zu.",
    per: "pro",
    tips_1: "Die Kaution von {currencyName} {yajin} wird zurückerstattet",
    tips_2:
      "Nach {pOvertimeDay} Tagen werden {currencyName} {overtimeAmount} berechnet"
  },
  rentcost: {
    rentcosttitle: "Wie viel kostet die Miete?",
    price1: "{currency} {jifei} pro {jifeiDanwei} {priceUnit}",
    price2: "{currency} {fengding} pro Tag",
    tip1:
      "Wenn du die Powerbank nicht innerhalb von {overtime} Tagen zurückgibst, werden dir {overtimeAmount} {currency} berechnet und du musst sie nicht zurückgeben.",
    tip2:
      "Ein Miettag entspricht 24 Stunden ab dem Zeitpunkt der Abholung der Powerbank.",
    tip3:
      "Wir berechnen {yajin} {currency} als Kaution, die zurückerstattet wird, sobald die Batterie an die Station zurückgegeben wird.",
    tip4: "Einige Standorte bieten kostenlose Stunden oder Rabatte. Viel Spaß!",
    Days: "Tage",
    Hours: "Stunden",
    Minutes: "Minuten",
    free: "{mianfei} Minuten kostenlos",
    willcharged: "Dir werden {currency} {money} berechnet"
  }
};
